import { Input, Modal, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { useGapReasonPending, useAnswerGapReason } from '../../api-hooks/gap-reason';

const { Text } = Typography;
const MEETING_OR_CALL_REGEX = /\b(meeting|call|phone)\b/i;

function formatTime(d) {
    return new Date(d).toLocaleString('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'short' });
}

export default function GapReasonGate() {
    const { data: pending } = useGapReasonPending();
    const { mutate: answer, isLoading } = useAnswerGapReason();
    const [reason, setReason] = useState('');
    const [leadNumber, setLeadNumber] = useState('');

    const needsLeadNumber = useMemo(() => MEETING_OR_CALL_REGEX.test(reason), [reason]);

    if (!pending) return null;

    const canSubmit = reason.trim() && (!needsLeadNumber || leadNumber.trim());

    const handleSubmit = () => {
        if (!canSubmit) return;
        answer({ id: pending._id, reason: reason.trim(), relatedLeadNumber: needsLeadNumber ? leadNumber.trim() : undefined }, {
            onSuccess: () => { setReason(''); setLeadNumber(''); }
        });
    };

    return (
        <Modal
            open
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={null}
            width={480}
            centered
        >
            <div className="py-2">
                <h3 className="font-semibold text-lg mb-2">Quick check-in</h3>
                <Text type="secondary">
                    We didn't see any activity between <b>{formatTime(pending.gapStart)}</b> and <b>{formatTime(pending.gapDetectedAt)}</b>.
                    No worries at all — just let us know what you were up to so we can keep our records accurate.
                </Text>
                <Input.TextArea
                    className="mt-3"
                    rows={3}
                    placeholder="e.g. Was on a call with a client, stepped out for lunch, etc."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    autoFocus
                />
                {needsLeadNumber && (
                    <Input
                        className="mt-2"
                        placeholder="Which lead was this for? (Lead Number)"
                        value={leadNumber}
                        onChange={(e) => setLeadNumber(e.target.value)}
                    />
                )}
                <button
                    className="mt-3 w-full bg-rose-500 disabled:bg-gray-300 text-white rounded-md py-2 font-medium"
                    disabled={!canSubmit || isLoading}
                    onClick={handleSubmit}
                >
                    {isLoading ? 'Submitting...' : 'Continue'}
                </button>
            </div>
        </Modal>
    );
}
